import React from 'react';
import PropTypes from 'prop-types';

import { ButtonOutlined, SvgIcon, Text, Flex } from 'Components/Base';

const FeedbackButton = ({ onClick, title, icon, iconColor, ...props }) => {
  return (
    <ButtonOutlined
      onClick={onClick}
      width={'100%'}
      height={48}
      borderRadius={2}
      color={'greyscale.grey4'}
      {...props}
    >
      <Flex justifyContent={'center'} alignItems={'center'}>
        <SvgIcon icon={icon} size={20} color={iconColor} mr={2} />
        <Text color={'text'} textStyle={'subtitle1'}>
          {title}
        </Text>
      </Flex>
    </ButtonOutlined>
  );
};

FeedbackButton.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  icon: PropTypes.object,
  iconColor: PropTypes.string,
};

export default FeedbackButton;
